(function ($) {
    $('.js-play-youtube-video').on('click', function (e) {
        const videoWrapper = document.querySelector('.js-youtube-video-wrapper');
        videoWrapper.style.display = "block";
        const iframe = videoWrapper.querySelector("iframe");

        iframe.contentWindow.postMessage('{"event":"command","func":"playVideo","args":""}', "*");
    });
})(jQuery)
